import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = [
  'en',
  'es',
  'de',
  'fr',
  'ja',
  'zh',
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export interface LanguageOption {
  label: string;
  value: SupportedLanguage;
}

// Keyed by SupportedLanguage rather than `string`: adding a code above without
// a label here becomes a tsc error, caught by the "Spec-level tsc (ONE)" check.
export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  ja: '日本語',
  zh: '中文',
};

export const LANGUAGE_OPTIONS: LanguageOption[] = SUPPORTED_LANGUAGES.map(
  (lng) => ({ label: LANGUAGE_LABELS[lng], value: lng }),
);

const cdnUrl = import.meta.env.VITE_I18N_CDN_URL || '';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    ns: ['common'],
    defaultNS: 'common',
    backend: {
      loadPath: `${cdnUrl}/locales/{{lng}}/{{ns}}.json`,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
